export class RenderingExtension {
    public name: string = '';
    public localizedName: string = '';
}
